import React, { useEffect, useState } from "react";
import { SettingOutlined } from "@ant-design/icons";
import { Spin } from "antd";
import { useTheme } from "../../utils/ThemeContext";
import DashboardInvestmentTableComponent from "./DashboardInvestmentTableComponent";
import DASHBOARD_API from "../../apis/dashboard.api";

const headers = ["Company", "Ticker", "Last", "Chg", "Chg %", ""];

const InvestmentWatchlistTable = () => {
  const { theme } = useTheme();
  const [loading, setLoading] = useState(false);
  const [storedStocksList, setStoredStocksList] = useState([]);

  const getStoredDocuments = async () => {
    try {
      setLoading(true)
      const response = await DASHBOARD_API.fetchStocks();
      console.log("stocks listings==>", response.data.rows);

      if (response && response.data) {
        setStoredStocksList(response.data.rows);
      }
      setLoading(false)
    } catch (error) {
      console.log("error while getting stock list==>", error);
      setLoading(false)

    }
  };

  useEffect(() => {
    getStoredDocuments();
  }, []);
  return (
    <div style={{ position:"relative",}}>
      <div
        style={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          backgroundColor: theme === "dark" ? "#232323" : "white",
        }}
      >
        <h3
          style={{
            color: theme === "light" ? "#232323" : "white",
          }}
        >
          Investment Watchlist
        </h3>
        <SettingOutlined />
      </div>
      <DashboardInvestmentTableComponent
        theme={theme}
        headers={headers}
        data={storedStocksList}
      />
      {loading ? (
        <div style={{ marginTop: "12px", display: "flex", justifyContent: "center", alignItems: "center", minHeight: "64px", borderRadius: "12px", border: "1px solid rgba(74, 98, 255, 0.35)", background: "linear-gradient(135deg, rgba(42, 61, 163, 0.16), rgba(42, 61, 163, 0.06))", boxShadow: "inset 0 1px 0 rgba(255,255,255,0.14)" }}>
          <Spin size="large" />
        </div>
      ) : null}
    </div>
  );
};

export default InvestmentWatchlistTable;
